<template>
  <div class="LoginFormMobile">
    <v-dialog />
    <template v-if="loading === false || ssoLoading === false">
      <h1
        class="LoginFormMobile-title"
        :class="{
          'LoginFormMobile-title--partner': typeMode === ACTUAL_ROLE.SPONSOR
        }"
      >
        {{ loginFormTitle }}
      </h1>
      <div>
        <form @submit.prevent="submitLogin">
          <div
            class="LoginFormMobile-subtitle"
            :class="{
              'LoginFormMobile-subtitle--partner':
                typeMode === ACTUAL_ROLE.SPONSOR
            }"
          >
            <span class="text">{{ $t('login.title') }}</span>

            <img
              :class="{ 'show-loader': loading }"
              class="LoginFormMobile-subtitle-loader"
              src="@/assets/animations/loader.svg"
              alt="loader"
            />
          </div>

          <div class="LoginFormMobile-element ">
            <LoginMail />

            <template v-if="isMethodePassword">
              <LoginPassword />
            </template>
          </div>

          <div class="LoginFormMobile-submit">
            <BSCButton
              typeButton="submit"
              :label="$t('login.label.connect')"
              :type="typeMode === ACTUAL_ROLE.TRAINER ? 'primary' : 'purple'"
              :disabled="!loginEnable"
              :loading="loadingButton"
            />
          </div>
        </form>
        <hr class="LoginFormMobile-separator" />
        <div
          id="LoginFormMobile-connection"
          class="LoginFormMobile-connection"
          @click="changeConnexionMethod"
        >
          {{ changeMethodeText }}
        </div>

        <div
          v-if="this.$allowSsoMicrosoft() && getRole() === ACTUAL_ROLE.TRAINER"
          class="LoginFormMobile-buttonsMicrosoft"
          v-on:click="microsoftConnect"
        >
          <div class="LoginFormMobile-buttonsMicrosoftContent">
            <div class="LoginFormMobile-icon">
              <img
                class="LoginFormMobile-microsoftIcon"
                src="@/assets/png/microsoft.png"
                alt="microsoft_login"
              />
            </div>
            <div class="LoginFormMobile-microsoftText">
              {{ $t('login.microsoftLogin') }}
            </div>
          </div>
        </div>

        <div v-else class="LoginFormMobile-emptyButtons"></div>

        <template v-if="this.$allowSSoGoogle()">
          <div
            class="LoginFormMobile-buttonsGoogle"
            v-show="getRole() === ACTUAL_ROLE.TRAINER"
          >
            <div ref="googleConnect"></div>
          </div>
        </template>

        <div
          v-if="getRole() === ACTUAL_ROLE.SPONSOR"
          class="LoginFormMobile-emptyButtons"
        ></div>

        <div class="LoginFormMobile-portal-button">
          <BSCButton
            v-if="isPortalEnabled"
            class="is-outline"
            :type="typeMode === ACTUAL_ROLE.TRAINER ? 'primary' : 'purple'"
            @click.native="handlePortalInput"
          >
            {{ portalButtonContent }}
          </BSCButton>
        </div>
      </div>
    </template>

    <div v-else class="TemplateModalSingle-loading">
      <img
        class="LayoutDefault-loading-img"
        src="@/assets/animations/loader-all.svg"
        alt="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import {
  ACTUAL_ROLE,
  CONNEXION_METHODE,
  LOGIN_ENTREPRISE,
  LOGIN_STEEP,
  MODE_SENDING_CODE,
  TYPE_LOGIN
} from '@/utils/consts'
import { getRoleByLocalStorage, isSsoAuthorize } from '@/utils/function'

import LoginMail from '@/components/login/LoginMail'
import LoginPassword from '@/components/login/LoginPassword'
import LoginListOrganisation from '@/components/login/LoginListOrganisation'
import LoginConnectionMode from '@/components/login/LoginConnectionMode'
import LoginCode from '@/components/login/LoginCode'
import LoginEntreprise from '@/components/login/LoginEntreprise'

import jwt_decode from 'jwt-decode'
import i18n from '@/modules/i18n'

export default {
  name: 'LoginFormMobile',
  emits: ['portal-input'],
  components: {
    LoginPassword,
    LoginMail
  },
  props: {
    isPortalEnabled: {
      type: Boolean
    },
    typeMode: {
      type: String
    }
  },
  data() {
    return {
      loadingButton: false,
      loading: true,
      ssoLoading: true,
      email: '',
      idToken: null,
      isConnectionWithGoogle: false
    }
  },
  computed: {
    ACTUAL_ROLE() {
      return ACTUAL_ROLE
    },
    ...mapGetters({
      error: 'auth/error',
      login_data: 'auth/login_data',
      steepLogin: 'auth/steepLogin',
      microsoftAccount: 'auth/getCurrentMicrosoftAccount',
      getConnectionWithPassword: 'auth/getConnectionWithPasswordOrPin',
      getIsMicrosoftEmailInvalid: 'auth/getIsMicrosoftEmailInvalid',
      getTypeMode: 'auth/getTypeMode'
    }),

    changeMethodeText() {
      switch (this.login_data.type) {
        case TYPE_LOGIN.EMAIL:
          return this.$t('login.password.link')
        case TYPE_LOGIN.PASSWORD:
          return this.$t('login.email.link')
        default:
          return this.$t('login.password.link')
      }
    },
    isMethodeMail() {
      return this.login_data.type === TYPE_LOGIN.EMAIL
    },
    isMethodePassword() {
      return this.login_data.type === TYPE_LOGIN.PASSWORD
    },
    loginEnable() {
      return this.login_data.email != null && this.login_data.email !== ''
    },
    googleAppId() {
      return process.env.VUE_APP_GOOGLE_CLIENT_ID
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL
    },
    loginFormTitle() {
      return this.typeMode === ACTUAL_ROLE.TRAINER
        ? this.$t('login.portal.trainer.access')
        : this.$t('login.portal.partner.access')
    },
    portalButtonContent() {
      return this.typeMode === ACTUAL_ROLE.TRAINER
        ? this.$t('login.portal.partner.button')
        : this.$t('login.portal.trainer.button')
    }
  },
  methods: {
    //TODO Use to disable loginForm when sso connection
    hideWhileRedirect() {
      return (
        this.$route.query.type === 'logout-end' ||
        this.$route.query.success === '1'
      )
    },
    handlePortalInput() {
      let payload = ACTUAL_ROLE.TRAINER
      this.typeMode === ACTUAL_ROLE.TRAINER
        ? (payload = ACTUAL_ROLE.SPONSOR)
        : payload
      this.$store.dispatch('auth/setTypeMode', payload)
      localStorage.setItem('type', payload)
    },

    onSuccessGoogleSso(response) {
      let responsePayload = jwt_decode(response.credential)

      this.$store
        .dispatch('auth/isSsoGoggleOrMicrosoftAuthorize', {
          browser: this.$browserDetect,
          email: responsePayload.email
        })
        .then(trainers => {
          let isGoogleAuthorize = false
          for (let trainer of trainers) {
            if (
              isSsoAuthorize(
                trainer,
                MODE_SENDING_CODE.OAUTH,
                CONNEXION_METHODE.NAME.GOOGLE
              )
            ) {
              isGoogleAuthorize = true
            }
          }

          if (!isGoogleAuthorize) {
            this.$store.dispatch('auth/setError', {
              title: i18n.t('utils.label.error'),
              message: i18n.t('login.error.noOrganizationGoogle')
            })
            this.showError()
          } else {
            this.email = responsePayload.email
            this.$store.dispatch('auth/changeUserEmail', responsePayload.email)
            this.$store.dispatch('auth/setTypeLogin', TYPE_LOGIN.SSO)
            this.idToken = response.credential
            this.loginAfterSSo()
          }
        })
    },

    async microsoftConnect() {
      //refer to https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/accounts.md#active-account-apis
      this.$msalInstance()
      await this.$msalInstance().initialize()
      await this.$msalInstance()
        .loginPopup()
        .then(res => {
          this.$store
            .dispatch('auth/isSsoGoggleOrMicrosoftAuthorize', {
              browser: this.$browserDetect,
              email: res.account.username
            })
            .then(trainers => {
              let isMicrosoftAuthorize = false
              for (let trainer of trainers) {
                if (
                  isSsoAuthorize(
                    trainer,
                    MODE_SENDING_CODE.OAUTH,
                    CONNEXION_METHODE.NAME.MICROSOFT
                  )
                ) {
                  isMicrosoftAuthorize = true
                }
              }

              if (!isMicrosoftAuthorize) {
                this.$store.dispatch('auth/setError', {
                  title: i18n.t('utils.label.error'),
                  message: i18n.t('login.error.noOrganizationMicrosoft')
                })
                this.showError()
              } else {
                this.$msalInstance().setActiveAccount(res.account)
                this.$router.push({ path: '/microsoft/connect' })
              }
            })
            .catch(e => {
              if (e.response.data.detail === 'Trainer could not be found') {
                this.$store.dispatch('auth/setError', {
                  title: i18n.t('utils.label.error'),
                  message: i18n.t('login.error.trainerNotFound')
                })
              } else {
                this.$store.dispatch('auth/setError', {
                  title: i18n.t('utils.label.error'),
                  message: i18n.t('login.error.error')
                })
              }
              this.showError()
            })
        })
        .catch(e => {
          if (e['errorCode']) {
            if (e['errorCode'] !== 'user_cancelled') {
              this.$modal.show('dialog', {
                title: this.$t('login.error.titlePopupMicrosoft'),
                text: this.$t('login.error.messagePopupMicrosoft'),
                draggable: false,
                adaptive: true,
                buttons: [
                  {
                    title: 'ok',
                    handler: () => {
                      this.$modal.hide('dialog')
                    }
                  }
                ]
              })
            }
          } else {
            this.$modal.show('dialog', {
              title: this.$t('utils.label.error'),
              text: this.$t('login.error.error'),
              draggable: false,
              adaptive: true,
              buttons: [
                {
                  title: 'ok',
                  handler: () => {
                    this.$modal.hide('dialog')
                  }
                }
              ]
            })
          }
        })
    },
    googleConnect() {
      localStorage.setItem('tmpOrganizationId', '-1')
      window.google.accounts.id.disableAutoSelect()
      this.isConnectionWithGoogle = true
    },
    submitLogin() {
      if (!this.loginEnable) return
      this.loading = true
      switch (this.login_data.type) {
        case TYPE_LOGIN.PASSWORD:
          this.$store.dispatch(
            'auth/setConnectionWithPasswordOrPin',
            CONNEXION_METHODE.PASSWORD
          )
          this.$store
            .dispatch('auth/sendLoginPassword', this.$browserDetect)
            .catch(e => {
              this.showError()
              this.$log.fatal(e)
            })
          break
        case TYPE_LOGIN.EMAIL:
        default:
          if (
            this.login_data.email === LOGIN_ENTREPRISE.S_CONNECT ||
            this.login_data.email === LOGIN_ENTREPRISE.S_DEMO
          ) {
            //connexion entreprise
            this.$store.dispatch('auth/sendLoginEntreprise').catch(e => {
              this.showError()
              this.$log.fatal(e)
            })
          } else {
            this.$store
              .dispatch('auth/sendLoginMail', this.$browserDetect)
              .catch(e => {
                this.showError()
                this.$log.fatal(e)
              })
          }
          break
      }
    },
    showError() {
      this.onCrispInfo(false)
      let dTitle = ''
      let dText = ''
      if (this.error.title !== '') dTitle = this.error.title
      else dTitle = this.$t('utils.error.title')

      if (this.error.message !== '') dText = this.$t(this.error.message)
      else dText = this.$t('errors.unknown')

      this.$modal.show('dialog', {
        title: dTitle,
        text: dText,
        draggable: false,
        adaptive: true,
        buttons: [
          {
            title: 'ok',
            handler: () => {
              this.$store.dispatch('auth/resetSteep')
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    cancelLogin() {
      this.loading = false
      this.loadingButton = false
      this.$store.dispatch('auth/resetSteep')
    },
    loginAfterSSo() {
      if (
        localStorage.getItem('tmpOrganizationId') == null ||
        localStorage.getItem('tmpOrganizationId') == '-1'
      ) {
        this.$store
          .dispatch('auth/loginInfo', {
            browser: this.$browserDetect,
            email: this.email
          })
          .then(trainers => {
            if (trainers === null || trainers.length === 0) {
              return
            }
            if (trainers.length > 1) {
              //multy orga
              this.$modal.show(
                LoginListOrganisation,
                {
                  connexion_method: this.isConnectionWithGoogle
                    ? CONNEXION_METHODE.SSO_GOOGLE
                    : null
                },
                {
                  draggable: false,
                  height: 'auto',
                  adaptive: true,
                  clickToClose: false
                },
                {
                  'before-close': this.LoginListOrganisationAfterClose
                }
              )
            } else {
              this.$log.debug('else tmpOrganizationId')

              localStorage.setItem(
                'tmpOrganizationId',
                trainers[0].organization.id
              )
              this.loginAfterSSo()
            }
          })
          .catch(e => {
            this.showError()
          })
      } else {
        this.$store
          .dispatch('auth/connectWithGoogle', {
            email: this.email,
            id_token: this.idToken,
            organisationId: localStorage.getItem('tmpOrganizationId')
          })
          .then(() => {
            this.$store
              .dispatch('auth/getOrganization')
              .then(organization => {
                this.$router.push('/').catch(() => {})
              })
              .catch(e => {
                this.$log.fatal(e)
                this.showError()
              })
          })
          .catch(e => {
            this.$log.fatal(e)
            this.showError()
          })
      }
    },
    continuLogin(steep) {
      switch (steep) {
        case LOGIN_STEEP.MULTI_ORGANISATION:
          this.loading = true
          this.$modal.hideAll()
          this.$modal.show(
            LoginListOrganisation,
            { connexion_method: this.getConnectionWithPassword },
            {
              draggable: false,
              height: 'auto',
              adaptive: true,
              clickToClose: false
            },
            {
              'before-close': this.LoginListOrganisationAfterClose
            }
          )
          break
        case LOGIN_STEEP.MULTI_METHODE:
          this.loading = true
          this.$modal.hideAll()
          this.$modal.show(
            LoginConnectionMode,
            {},
            {
              draggable: false,
              height: 'auto',
              adaptive: true,
              clickToClose: false
            },
            {
              'before-close': this.cancelLogin
            }
          )
          break
        case LOGIN_STEEP.END:
          this.loading = true
          this.$modal.hideAll()
          this.$store
            .dispatch('auth/finishLogin', this.$browserDetect)
            .then(() => {})
            .catch(e => {
              this.$log.fatal('error in login', e)
              this.showError()
            })
          break
        case LOGIN_STEEP.CODE:
          this.loading = true
          this.$modal.hideAll()
          this.$modal.show(
            LoginCode,
            {},
            {
              draggable: false,
              height: 'auto',
              adaptive: true,
              clickToClose: false
            },
            {
              'before-close': this.cancelLogin
            }
          )
          break
        case LOGIN_STEEP.END_CODE:
          if (getRoleByLocalStorage() === ACTUAL_ROLE.TRAINER) {
            if (localStorage.getItem('modalConnection')) {
              this.loading = true
              this.$store
                .dispatch('auth/getOrganizationByModalConnection')
                .then(() => {})
                .catch(e => {
                  this.$log.fatal(e)
                  this.showError()
                })
            } else {
              this.loading = true
              this.$store
                .dispatch('auth/getOrganization')
                .then(() => {})
                .catch(e => {
                  this.$log.fatal(e)
                  this.showError()
                })
            }
          } else if (getRoleByLocalStorage() === ACTUAL_ROLE.SPONSOR) {
            this.loading = true
            this.$store
              .dispatch('auth/redirectSponsorDocumentsPage')
              .then(() => {})
              .catch(e => {
                this.$log.fatal(e)
                this.showError()
              })
          }
          break
        case LOGIN_STEEP.ENTREPRISE:
          this.loading = true
          this.$modal.hideAll()
          this.$modal.show(
            LoginEntreprise,
            {},
            { draggable: false, height: 'auto', adaptive: true },
            {
              'before-close': this.cancelLogin
            }
          )
          break
        case LOGIN_STEEP.REDIRECT:
          this.loading = false
          if (getRoleByLocalStorage() === ACTUAL_ROLE.TRAINER)
            this.$router.push('/').catch(() => {})
          else if (getRoleByLocalStorage() === ACTUAL_ROLE.SPONSOR)
            this.$router.push('/documents').catch(() => {})
          break
        case LOGIN_STEEP.ERROR:
          this.loading = false
          this.showError()
          break
        case LOGIN_STEEP.TOKEN_EXPIRED:
          this.loading = false
          this.$store.dispatch('utils/addToast', {
            label: this.$t('login.error.expiredToken'),
            type: 'danger'
          })
          break
        case LOGIN_STEEP.NULL:
        default:
          this.loading = false
          break
      }
    },
    changeConnexionMethod() {
      this.onCrispInfo(false)
      switch (this.login_data.type) {
        case TYPE_LOGIN.PASSWORD:
          this.$store.dispatch('auth/changeConnexionMethod', TYPE_LOGIN.EMAIL)
          break
        case TYPE_LOGIN.EMAIL:
        default:
          this.$store.dispatch(
            'auth/changeConnexionMethod',
            TYPE_LOGIN.PASSWORD
          )
          break
      }
    },
    LoginListOrganisationAfterClose() {
      if (
        localStorage.getItem('tmpOrganizationId') == null ||
        localStorage.getItem('tmpOrganizationId') == '-1'
      ) {
        this.cancelLogin()
      } else {
        this.loginAfterSSo()
      }
    },
    onCrispInfo(isReset) {
      if (!this.$allowCrisp()) {
        return
      }

      if (isReset === true) {
        $crisp.push(['do', 'session:reset'])
      }
      try {
        $crisp.push([
          'set',
          'session:data',
          [
            [
              ['connexion_methode', this.login_data.connexionMethode],
              ['erreur', this.error.message ? this.error.message : '']
            ]
          ]
        ])
      } catch (e) {
        this.$log.debug(e)
      }
    },

    getRole() {
      return this.getTypeMode
    }
  },
  async mounted() {
    // If the microsoft mail is invalid for the connection
    if (this.microsoftAccount && this.getIsMicrosoftEmailInvalid) {
      const loginRequest = {
        scopes: ['user.read'],
        prompt: 'select_account'
      }
      await this.$msalInstance()
        .loginPopup(loginRequest)
        .then(res => {
          this.$msalInstance().setActiveAccount(res.account)
          this.$store.dispatch('auth/setMicrosoftEmailInvalid', false)
          this.$router.push({ path: '/microsoft/connect' })
        })
        .catch(e => {
          if (e['errorCode'] !== 'user_cancelled') this.showError()
        })
    }

    this.onCrispInfo(true)

    window.google.accounts.id.initialize({
      client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      callback: this.onSuccessGoogleSso,
      mode_ux: 'redirect',
      intermediate_iframe_close_callback: 'logBeforeClose',
      itp_support: true,
      use_fedcm_for_prompt: true
    })
    const parent = this.$refs.googleConnect

    window.google.accounts.id.renderButton(parent, {
      theme: 'outline',
      click_listener: this.googleConnect
    })

    if (localStorage.getItem('tmpOrganizationId'))
      localStorage.removeItem('tmpOrganizationId')

    await this.$store.dispatch('utils/loading', false) //for clean bad loading

    if (this.$route.query.type === 'logout-end') {
      this.ssoLoading = false

      // Delete URL parameters
      window.history.replaceState(null, '', window.location.pathname)

      localStorage.setItem('type', this.getTypeMode)
    } else if (localStorage.getItem('url_redirection') !== null) {
      if (this.$route.query.success === '1') {
        await this.$store.dispatch('auth/setStepLogin', LOGIN_STEEP.END_CODE)
      } else {
        this.ssoLoading = false
        await this.$store.dispatch('utils/setError', {
          title: this.$t('utils.label.error'),
          message: this.$t('login.error.ssoError')
        })
        localStorage.clear()
      }
    }
  },
  watch: {
    steepLogin: {
      immediate: true,
      handler(newVal) {
        this.continuLogin(newVal)
      }
    }
  }
}
</script>

<style lang="scss">
.LoginFormMobile {
  display: flex;
  flex-direction: column;
  justify-content: center;

  &-icon {
    width: 20px;
    height: 20px;
  }

  &-title {
    @include typo-heading-1();

    display: inline-block;
    word-break: break-word;
    border-bottom: solid;
    width: 80%;
    text-align: center;

    color: $primary;
    margin-bottom: 80px;

    &--partner {
      color: $purple;

      &:before {
        background-color: $purple;
      }
    }
  }

  &-subtitle {
    @include typo-heading-2();

    display: flex;
    align-items: center;

    color: $primary;

    &--partner {
      color: $purple;
    }

    &-loader {
      width: 50px;
      height: 50px;
      visibility: hidden;

      &.show-loader {
        visibility: initial;
      }
    }
  }

  &-separator {
    border: none;
    height: 1px;
    background-color: $grey;
    width: 100%;
  }

  &-connection {
    cursor: pointer;
    text-decoration: underline;
    margin-top: 10px;
    text-align: center;
    color: $grey-dark;
    width: 100%;

    &:hover {
      text-decoration: none;
    }
  }

  &-element {
    margin: 1rem 0;
    width: 100%;

    &-input > input {
      width: 200px;
    }
  }

  &-submit {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
  }

  &-buttonsMicrosoft {
    margin-top: 20px;
    margin-bottom: 20px;
    width: 100%;
    cursor: pointer;
    border-radius: 4px;
    background-color: #e6e6e6;
    color: #5e5e5e;
    border-color: #cfd9df;
  }

  &-buttonsGoogle {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
  }

  &-buttonsMicrosoftContent {
    padding: 10px;
    display: flex;
  }

  &-microsoftText {
    margin-left: 30px;
    color: black;
  }

  &-microsoftIcon {
    width: 100%;
    float: left;
  }

  &-emptyButtons {
    height: 40px;
    margin: 20px 0 20px 0;
  }

  &-portal {
    &-button {
      justify-content: center;
    }
  }
}
</style>
